(() => {
  if (window.vaslCasesLoaded) return;
  window.vaslCasesLoaded = true;
  const values = (card, key) => {
    const value = card.dataset[key] || '';
    if (key !== 'finish' && key !== 'type') return value ? [value] : [];
    try { const parsed = JSON.parse(value); return Array.isArray(parsed) ? parsed : []; } catch { return []; }
  };
  async function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const grid = root.querySelector('[data-cards]');
    const status = root.querySelector('[data-status]');
    const fragment = document.createDocumentFragment();
    let next = root.dataset.next;
    let page = root;
    const seen = new Set();
    const fetchPage = async (path) => {
      const url = new URL(path, location.href);
      if (url.origin !== location.origin) throw new Error('Unexpected origin');
      url.searchParams.set('section_id', root.dataset.section);
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      const response = await fetch(url, {signal: AbortSignal.timeout(15000)});
      if (!response.ok) throw new Error('Unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const result = [...doc.querySelectorAll('[data-case-gallery]')].find(el => el.dataset.section === root.dataset.section);
      if (!result) throw new Error('Missing gallery');
      return result;
    };
    try {
      if (Number(root.dataset.current) > 1) {
        const first = new URL(location.href);
        first.searchParams.set(root.dataset.param || 'page', '1');
        page = await fetchPage(first);
        next = page.dataset.next;
      }
      const collect = source => source.querySelectorAll('[data-case-card]').forEach(card => {
        if (!seen.has(card.dataset.id)) {seen.add(card.dataset.id); fragment.append(card.cloneNode(true));}
      });
      collect(page);
      const visited = new Set();
      while (next) {
        if (visited.has(next)) throw new Error('Repeated page');
        visited.add(next);
        page = await fetchPage(next);
        collect(page);
        next = page.dataset.next;
      }
      if (!root.isConnected) return;
      grid.replaceChildren(fragment);
      root.querySelector('[data-pagination]').hidden = true;
      const cards = [...grid.querySelectorAll('[data-case-card]')];
      const selects = [...root.querySelectorAll('[data-filter]')];
      const vehicleKeys = ['make', 'vehicle', 'generation', 'trim'];
      const refreshOptions = () => {
        selects.forEach(select => {
          const key = select.dataset.filter;
          const level = vehicleKeys.indexOf(key);
          const parents = level > 0 ? vehicleKeys.slice(0, level) : [];
          const candidates = cards.filter(card => parents.every(parent => {
            const selected = selects.find(item => item.dataset.filter === parent)?.value;
            return !selected || values(card, parent).includes(selected);
          }));
          const available = [...new Set(candidates.flatMap(card => values(card, key)))].sort((a,b) => a.localeCompare(b));
          const previous = select.value;
          const allLabel = select.options[0].textContent;
          select.replaceChildren(new Option(allLabel, ''));
          available.forEach(value => {
            const label = key === 'type' ? root.querySelector(`[data-type-${value}]`)?.textContent || value : value;
            select.add(new Option(label, value));
          });
          select.value = available.includes(previous) ? previous : '';
          select.disabled = available.length === 0;
        });
      };
      refreshOptions();
      let limit = 12;
      const more = root.querySelector('[data-more]');
      const update = () => {
        let matched = 0;
        cards.forEach(card => {
          const match = selects.every(select => !select.value || values(card, select.dataset.filter).includes(select.value));
          card.hidden = !match || ++matched > limit;
        });
        status.textContent = root.dataset.count.replace('[count]', String(matched));
        root.querySelector('[data-empty]').hidden = matched !== 0;
        more.hidden = matched <= limit;
      };
      selects.forEach(select => select.addEventListener('change', () => {
        const level = vehicleKeys.indexOf(select.dataset.filter);
        if (level >= 0) selects.forEach(other => {if (vehicleKeys.indexOf(other.dataset.filter) > level) other.value = '';});
        refreshOptions(); limit = 12; update();
      }));
      root.querySelector('[data-reset]').addEventListener('click', () => {selects.forEach(select => {select.value = '';}); refreshOptions(); limit = 12; update();});
      more.addEventListener('click', () => {limit += 12; update();});
      root.querySelector('[data-filters]').hidden = false;
      update();
    } catch { status.textContent = root.dataset.error; }
  }
  const scan = (scope = document) => scope.querySelectorAll('[data-case-gallery]').forEach(init);
  scan();
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
